import { useRef } from 'react';
import emailjs from '@emailjs/browser';

function Contact() {
  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();
    emailjs.sendForm(
      'service_9th5yan',
      'template_07auzme',
      form.current,
      'G7RpeT17lJk35HKBm'
    ).then(() => {
      alert('Message sent successfully! ✅');
      form.current.reset();
    }).catch(() => {
      alert('Something went wrong. Please try again.');
    });
  };

  return (
    <div style={{ padding: '60px 40px', maxWidth: '900px', margin: '0 auto' }}>
      <h1 style={{ color: '#1a6b3c', fontSize: '36px', marginBottom: '10px' }}>Contact Us</h1>
      <p style={{ color: '#555', fontSize: '18px', marginBottom: '40px' }}>
        We'd love to hear from you!
      </p>

      <div style={{ display: 'flex', gap: '40px', flexWrap: 'wrap', marginBottom: '50px' }}>
        <div style={{ flex: 1, minWidth: '250px' }}>
          {[
            { icon: '📍', label: 'Address', value: 'Shantha Kaliyamman Koil St, Kandhanpalayam, L.N.Puram, Panruti - 607106, Cuddalore Dist.' },
            { icon: '📞', label: 'Phone', value: '+91 96298 80881' },
            { icon: '✉️', label: 'Email', value: 'lnslnpprt@gmail.com' },
            { icon: '🕐', label: 'Office Hours', value: 'Mon - Sat: 8:00 AM – 4:00 PM' },
          ].map((item, i) => (
            <div key={i} style={{ marginBottom: '24px', display: 'flex', gap: '14px' }}>
              <span style={{ fontSize: '24px' }}>{item.icon}</span>
              <div>
                <div style={{ fontWeight: 'bold', color: '#1a6b3c' }}>{item.label}</div>
                <div style={{ color: '#555' }}>{item.value}</div>
              </div>
            </div>
          ))}
        </div>

        <div style={{ flex: 1, minWidth: '250px' }}>
          <form ref={form} onSubmit={sendEmail}>
            <input name="user_name" placeholder="Your Name" required style={{
              width: '100%', padding: '12px', marginBottom: '16px',
              border: '1px solid #ccc', borderRadius: '6px', fontSize: '15px'
            }} />
            <input name="user_email" placeholder="Email Address" required style={{
              width: '100%', padding: '12px', marginBottom: '16px',
              border: '1px solid #ccc', borderRadius: '6px', fontSize: '15px'
            }} />
            <input name="user_phone" placeholder="Phone Number" style={{
              width: '100%', padding: '12px', marginBottom: '16px',
              border: '1px solid #ccc', borderRadius: '6px', fontSize: '15px'
            }} />
            <textarea name="message" placeholder="Your Message" rows={4} required style={{
              width: '100%', padding: '12px', border: '1px solid #ccc',
              borderRadius: '6px', fontSize: '15px', marginBottom: '16px'
            }} />
            <button type="submit" className="btn">Send Message</button>
          </form>
        </div>
      </div>

      <h2 style={{ color: '#1a6b3c', marginBottom: '20px' }}>📍 Find Us Here</h2>
      <iframe
        title="School Location"
        src="https://maps.google.com/maps?q=Kandhanpalayam,Panruti,Cuddalore,Tamil+Nadu+607106&output=embed"
        width="100%"
        height="380"
        style={{ borderRadius: '12px', border: 'none', boxShadow: '0 4px 15px rgba(0,0,0,0.1)' }}
        allowFullScreen
        loading="lazy"
      />
    </div>
  );
}

export default Contact;